import { render, staticRenderFns } from "./WikiMenu.vue?vue&type=template&id=16def122&"
import script from "./WikiMenu.vue?vue&type=script&lang=js&"
export * from "./WikiMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports